<div class="container" style="display: flex; flex-direction:column; height:100%">

  <h3 i18n class="display-6" align="center" style="padding-top: 10px; color: #005d87; font-weight: bold;">
        Table Population Options
    </h3>


  <form [formGroup]="offloadForm">

    <!-- Question 1 -->

    <div class="row">
      <h6 i18n class="question-text">
                What catch do you want to include?
            </h6>
      <mat-form-field appearance="fill">
        <mat-label i18n>
                    Select
                    </mat-label>
        <mat-select formControlName="dataType">
          @for (answer of ['All catch reports from this trip', 'Specific catch reports from this trip']; track answer) {
            <mat-option i18n
              [value]="answer">
                        {answer, select, All catch reports from this trip {All catch reports from this trip} Specific catch reports from this trip {Specific catch reports form this trip}}
                    </mat-option>
          }
        </mat-select>
        @if (offloadForm.invalid) {
          <mat-error i18n>
                        Required
                    </mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Question 2 - Appears if they want to select specific Catch Reports -->

    @if (selectReports) {
      <div class="row">
        <h6 i18n class="question-text">
                How would you like to choose your daily catch reports?
            </h6>
        <mat-form-field appearance="fill">
          <mat-label i18n>
                    Select
                    </mat-label>
          <mat-select formControlName="selectionType">
            @for (answer of ['Select by date', 'Select from list']; track answer) {
              <mat-option i18n
                [value]="answer">
                        {answer, select, Select by date {Select by date} Select from list {Select from list}}
                    </mat-option>
            }
          </mat-select>
          @if (offloadForm.invalid) {
            <mat-error i18n>
                        Required
                    </mat-error>
          }
        </mat-form-field>
        <!-- Date Range Picker -->
        @if (dateSelection) {
          <div class="row"
            align="center"
            >
            <mat-form-field appearance="fill">
              <mat-label i18n>
                    Enter a Date Range
                    </mat-label>
              <mat-date-range-input [rangePicker]="picker">
                <input matStartDate
                  formControlName="startDate"
                  placeholder="Start date"
                  i18n-placeholder="Start date placeholder"/>
                  <input matEndDate
                    formControlName="endDate"
                    placeholder="End date"
                    i18n-placeholder="End date placeholder"/>
                  </mat-date-range-input>
                  <mat-hint class="small-text">
                    MM/DD/YYYY – MM/DD/YYYY
                  </mat-hint>
                  <mat-datepicker-toggle matIconSuffix
                  [for]="picker"></mat-datepicker-toggle>
                  <mat-date-range-picker touchUi
                  #picker></mat-date-range-picker>
                </mat-form-field>
              </div>
            }
            <!-- Report Picker (Select From List) -->
            @if (listSelection) {
              <div class="row"
                align="center"
                >
                <mat-form-field appearance="fill"
                  class="form-field">
                  <mat-label i18n>
                    Select Reports
                    </mat-label>
                  <mat-select [formControl]="catchReportList"
                    multiple>
                    <mat-select-trigger i18n>
                            Total Reports Selected: {{catchReportList.value?.length}}
                        </mat-select-trigger>
                    @for (report of catchReportData.reverse(); track report) {
                      <mat-option
                        [value]="report"
                        style="font-size: 15px;">
                        {{ sharedMethodsService.getDate(report.dateFished) | date: 'dd/MM/yyyy' }} (
                        @for (species of makeCatchList(report.speciesDataList); track species; let y = $index) {
                          <div
                            style="display: inline">
                            @if (y < (makeCatchList(report.speciesDataList).length - 1)) {
                              <small
                                style="font-size: 12px;">
                                {{species.speciesName}}: {{species.kept}},
                              </small>
                            }
                            @if (y === (makeCatchList(report.speciesDataList).length - 1)) {
                              <small
                                style="font-size: 12px;">
                                {{species.speciesName}}: {{species.kept}}
                              </small>
                            }
                          </div>
                        }
                        )
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
          </div>
        }

        <!-- Question 3 -->

        <div class="row">
          <h6 i18n class="question-text">
                Would you like to include total pieces?
                <br>
                <small> 
                    If you select no, "pieces" will remain at 0.
                </small>
            </h6>
            <mat-form-field appearance="fill">
              <mat-label i18n>
                    Select
                    </mat-label>
              <mat-select formControlName="piecesIncluded">
                @for (answer of ['Yes', 'No']; track answer) {
                  <mat-option i18n
                    [value]="answer">
                        {answer, select, Yes {Yes} No {No}}
                      </mat-option>
                }
              </mat-select>
              @if (offloadForm.invalid) {
                <mat-error i18n>
                        Required
                    </mat-error>
              }
            </mat-form-field>
          </div>

        </form>

        <!-- Bottom Buttons -->

        <div class="row bottom-buttons">

          <div class="outer">

            <div class="inner" style="margin-right: 40%">
              <button i18n mat-stroked-button
                type="button"
                style="background-color: #005d87; color: white; font-weight: bold;"
                (click)="closeDialog()">
                    Back
                </button>
            </div>


            <div class="inner">
              <button i18n mat-stroked-button
                type="submit"
                style="background-color: #ff6f61; color: white; font-weight: bold;"
                (click)="populateTable()">
                    Apply
                </button>
            </div>

          </div>

        </div>

      </div>
